import axios from 'axios'
let Base64 = require('js-base64').Base64;
import qs from "qs";

// const baseUrl = 'https://gqxbq1013.com/api' // 方块
const baseUrl = 'https://9cdyy.vip/api' // 阿杰

//创建axios实例对象
const http = axios.create({
    baseURL: baseUrl, //服务器地址
    timeout: 20000, //默认超时时长
})

//请求拦截器
http.interceptors.request.use(config => {
    const token = localStorage.getItem('token')
    const lang = localStorage.getItem('lang') || 'en_us'
    if (config.method === "post") {
        config.headers = {
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8', // 设置跨域头部
        }
        config.data = qs.stringify(config.data)
    }
    if (token) {
        config.headers = {
            token: Base64.encode(token),
            lang: lang.toLowerCase()
        }
    }
    return config
}, err => {
    console.error('请求失败', err)
})

//响应拦截器
http.interceptors.response.use(res => {
    res.data.data = JSON.parse(Base64.decode(res.data.data))
    //此处对响应数据做处理
    // if (res.data.msg === "鉴权错误") {
    //     localStorage.clear();
    //     this.$router.push({
    //         path: '/Login'
    //     })
    // }
    return res.data //该返回对象会传到请求方法的响应对象中
}, err => {
    // 响应错误处理
    return Promise.reject(err);
})

// 上传图片
const imgUpload = async (file) => {
    const formData = new FormData()
    formData.append("file", file)
    const url = baseUrl + '/system/img_upload'
    const token = localStorage.getItem('token')
    const lang = localStorage.getItem("lang") || 'en_us'

    const headers = {
        'Content-Type': 'multipart/form-data',
        token: Base64.encode(token),
        lang: lang.toLowerCase(),
    }
    if (token) headers.token = Base64.encode(token)

    const res = await axios.post(url, formData, { headers })
    const imgPath = JSON.parse(Base64.decode(res.data.data)).img_path;

    return imgPath
}

export {
    http,
    imgUpload
}

